import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SecurityService } from '../../services/security.service';
import { RouterOutlet } from '@angular/router';
import { RouteService } from '../../services/route.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-header',
  imports: [
    CommonModule,
    RouterOutlet
],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent{

  colorOne = environment.colorOne;
  colorTwo = environment.colorTwo;
  webVersion = localStorage.getItem('version');

  showBack = signal(true);
  backRoute = signal('');
  consultor = signal<any | null>(null);
  currentRoute: string = '';

  constructor(
    private router: Router,
    private securityService: SecurityService,
    private _routeService: RouteService
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.urlAfterRedirects;
        this.showBack.set(this._routeService.compare(this.currentRoute));
        this.consultor.set(this.securityService.getConsultorInfo());
        this.backRoute.set(this._routeService.getBackRoute(this.currentRoute) ?? '');
      }
    });
  }

  async back() {
    localStorage.setItem('route', this.backRoute());
    this.backRoute.set(this._routeService.getBackRoute(this.currentRoute) ?? '');
    this.router.navigateByUrl(this.backRoute());
  }
}
